export default [{
	path: 'accounts',
	name: 'Account',
	component: resolve => require(['@/views/Account/index.vue'], resolve),
	meta: {
		title: '用户列表',
		name: 'Account',
	}
}];


// WEBPACK FOOTER //
// ./src/router/modules/account.route.js